import { render, staticRenderFns } from "./reciboPagos.vue?vue&type=template&id=24c5690a&scoped=true"
import script from "./reciboPagos.vue?vue&type=script&lang=js"
export * from "./reciboPagos.vue?vue&type=script&lang=js"
import style0 from "./reciboPagos.vue?vue&type=style&index=0&id=24c5690a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5690a",
  null
  
)

export default component.exports